import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(persistUserLocation);

import { call, put } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { DAY_MS } from 'constants/time-and-date';
import { setUserSelectedLocation } from 'redux/modules/locale';
import { writeLocalStorage } from './local-storage';
export function persistUserLocation(lat, lon) {
  return regeneratorRuntime.wrap(function persistUserLocation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!lat || !lon || lat === 0 && lon === 0)) {
            _context.next = 4;
            break;
          }

          _context.next = 3;
          return call(logger.warn, 'Location: Failed with persisting invalid lat and lon values', lat, lon);

        case 3:
          return _context.abrupt("return");

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return put(setUserSelectedLocation(lat, lon));

        case 7:
          _context.next = 9;
          return call(writeLocalStorage, 'userLocation', {
            lat: lat,
            lon: lon,
            expires: Date.now() + DAY_MS * 30
          });

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](4);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 11]]);
}